'use strict';

const Mn = require('backbone.marionette');
const NodeInfoView = require('system/ui/view/detail/node-info');
const NodeEditView = require('system/ui/view/detail/node-edit');
const LinkInfoView = require('system/ui/view/detail/link-info');
const LinkEditView = require('system/ui/view/detail/link-edit');
const ElementRepository = require('system/domain/repository/element');
const Template = require('balus/ui/template/body/diagram/content/detail.hbs');

module.exports = Mn.View.extend({
    template: Template,
    regions: {
        detail: '#detail-pane'
    },

    onRender: function() {
        const context = this.getOption('context');
        const oldContext = this.getOption('oldContext');
        const channel = this.getOption('channel');

        this.listenTo(channel, 'canvas:click', this.hide);

        const nodes = ElementRepository.getNodes({
            context: oldContext
        });
        this.listenTo(nodes, 'select', this.renderNodeDetail);
        this.listenTo(nodes, 'change:edit', this.renderNodeDetail);
        this.listenTo(nodes, 'deselect', this.hide);

        const links = ElementRepository.getLinks({
            context: oldContext
        });
        this.listenTo(links, 'select', this.renderLinkDetail);
        this.listenTo(links, 'change:edit', this.renderLinkDetail);
        this.listenTo(links, 'deselect', this.hide);


        const selectedNodes = channel.request('req:nodes:selected');
        const selectedLinks = channel.request('req:links:selected');
        if(selectedNodes.length + selectedLinks.length == 1) {
            if(selectedNodes.length == 1) {
                const node = nodes.get(selectedNodes[0].id);
                if(node) {
                    this.renderNodeDetail(node);
                }
            } else {
                const link = links.get(selectedLinks[0].id);
                if(link) {
                    this.renderLinkDetail(link);
                }
            }
        }
    },

    renderNodeDetail: function(node) {
        const auth = this.getOption('auth');
        const context = this.getOption('context');
        const oldContext = this.getOption('oldContext');
        const channel = this.getOption('channel');
        const group = this.getOption('group');
        const project = this.getOption('project');

        if(!this.model.getNodeMeta(node.id)) {
            return;
        }
        if(!node.selected) {
            return;
        }
        if(auth.isMultiSelectable()) {
            return;
        }
        const viewClass = node.editing ? NodeEditView : NodeInfoView;
        const view = new viewClass({
            model: node,
            group: group,
            project: project,
            diagram: this.model,
            channel: channel,
            context: oldContext,
            newContext: context,
            auth: auth,
            appInfo: this.getOption('appInfo')
        });
        this.showChildView('detail', view);
        this.listenTo(view, 'hide', this.hide);

        setTimeout(() => {
            this.show();
        }, 10);

        view.on('add:comment', model => {
            channel.trigger('append:comment:record', model);
        });
        view.on('filter:comment', str => {
            channel.trigger('filter:comment', str);
        });
        view.on('add:rlink', rlink => {
            channel.request('cmd:add:rlink', rlink);
        });
    },

    renderLinkDetail: function(link) {
        const auth = this.getOption('auth');
        const context = this.getOption('context');
        const oldContext = this.getOption('oldContext');
        const channel = this.getOption('channel');
        const group = this.getOption('group');
        const project = this.getOption('project');

        if(!this.model.getLinkMeta(link.id)) {
            return;
        }
        if(!link.selected) {
            return;
        }
        const viewClass = link.editing ? LinkEditView : LinkInfoView;
        const view = new viewClass({
            model: link,
            group: group,
            project: project,
            diagram: this.model,
            channel: channel,
            context: oldContext,
            newContext: context,
            auth: auth
        });
        this.showChildView('detail', view);
        this.listenTo(view, 'hide', this.hide);

        setTimeout(() => {
            this.show();
        }, 10);

        view.on('add:comment', model => {
            channel.trigger('append:comment:record', model);
        });

        view.on('filter:comment', str => {
            channel.trigger('filter:comment', str);
        });
    },

    show: function() {
        this.$('#detail-pane').addClass('is-shown');
    },

    hide: function() {
        this.$('#detail-pane').removeClass('is-shown');
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/diagram/content/detail.js